import React from "react";
import { RenderVideoProps } from "../types";
import { getImageUrl } from "@provider";

const RenderVideo: React.FC<RenderVideoProps> = ({ video }) => {
  return (
    <video
      controls
      width="100%"
      css={{ width: "100%", height: "auto" }}
      src={getImageUrl({ filePath: video })}
    />
  );
};

export default RenderVideo;
